import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./selectable-card-floor.module.scss";
import FloorListEntry from "./floor-list-entry";
import { mapFloorNumber } from "../../../../../helper/language-helper";
import VelavuIconButton from "../../../../../elements/velavu-icon-button";
import IconMoreHorizontal from "../../../../../dynamicicons/icon-more-horizontal";
import SelectableCard from "../../../../../elements/selectable-card";
import { classArr } from "../../../../../helper/style-helper";
import LoadingDots from "../../../../../elements/loading-dots";
import whitelabel from "../../../../../whitelabel";

export interface SelectableCardFloorProps {
	entry: FloorListEntry;
	selected?: boolean;
	onClick?: () => void;
	onClickMore?: (
		event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
	) => void;
}

export default function SelectableCardFloor(props: SelectableCardFloorProps) {
	const { t } = useTranslation();
	return (
		<SelectableCard
			className={classArr(
				styles.floorCard,
				props.selected && styles.floorCardSelected,
				props.entry.loading && styles.floorCardLoading,
			)}
			disableHover={props.entry.loading}
			onClick={props.onClick}
		>
			<span className={styles.floorNumber}>
				{mapFloorNumber(props.entry.level, t)}
			</span>
			<span className={styles.floorName}>{props.entry.name}</span>
			{props.entry.loading ? (
				<LoadingDots
					className={styles.loadingIndicator}
					color={whitelabel.palette.secondary700}
					size={16}
				/>
			) : props.onClickMore !== undefined ? (
				<VelavuIconButton
					className={styles.moreButton}
					onClick={props.onClickMore}
					small
				>
					<IconMoreHorizontal
						color={whitelabel.palette.secondary700}
					/>
				</VelavuIconButton>
			) : null}
		</SelectableCard>
	);
}
